import React from 'react';
import { Link } from 'react-router-dom';
import Seo from '../components/Seo';
import Base64Validator from '../components/Base64Validator';
import FaqSection from '../components/Faq';
import { PageHero } from '../components/InfoSections';
import { softwareApplicationSchema, faqPageSchema, breadcrumbSchema, Faq } from '../lib/schema';

const FAQS: Faq[] = [
  { q: 'What makes a string valid Base64?', a: 'It must use only the Base64 alphabet (A-Z, a-z, 0-9, "+" and "/", or "-" and "_" for the URL-safe variant), have a length that is a multiple of 4 for standard Base64, and use "=" padding only at the end.' },
  { q: 'Why did my Base64 string fail validation?', a: 'The most common causes are: extra whitespace or line breaks copied by accident, a mix of standard and URL-safe characters, missing "=" padding, or the string being truncated.' },
  { q: 'Does this tool tell me what the decoded content is?', a: 'No — this tool only checks whether the string is structurally valid Base64. Use the Base64 Decode tool to see the actual decoded output.' },
  { q: 'Can valid Base64 still decode to garbage?', a: 'Yes. Any string that follows the Base64 alphabet rules will decode to some sequence of bytes, but those bytes are only meaningful if the original data made sense — validity does not guarantee the content is what you expect.' },
];

export default function Base64ValidatorPage() {
  return (
    <>
      <Seo
        title="Base64 Validator — Check If a String Is Valid Base64 | EasyBase64"
        description="Check whether a string is valid Base64 or URL-safe Base64 for free. Instantly see why a string fails, with the exact reason — invalid characters, padding or length."
        path="/base64-validator"
        jsonLd={[
          softwareApplicationSchema({ name: 'Base64 Validator', description: 'Check whether a string is valid standard or URL-safe Base64.', path: '/base64-validator' }),
          faqPageSchema(FAQS),
          breadcrumbSchema([{ name: 'Home', path: '/' }, { name: 'Base64 Validator', path: '/base64-validator' }]),
        ]}
      />
      <PageHero
        title="Base64 Validator"
        subtitle={<>Check whether a string is valid Base64, and see exactly why if it isn't. Hitting decode errors? Read <Link to="/base64-encoding-errors" className="underline">common Base64 errors and fixes</Link>.</>}
      />
      <div className="mb-12 max-w-3xl mx-auto">
        <Base64Validator />
      </div>
      <FaqSection title="Base64 Validator — FAQ" faqs={FAQS} />
    </>
  );
}
